import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const API = 'https://groovie-business-api-production.up.railway.app/api/v1';

const BUSINESS_TYPES = [
  { value: 'retail_store', label: 'Retail Store' },
  { value: 'restaurant', label: 'Restaurant' },
  { value: 'gym', label: 'Gym / Fitness' },
  { value: 'hotel', label: 'Hotel' },
  { value: 'spa', label: 'Spa / Wellness' },
  { value: 'corporate', label: 'Corporate Office' },
  { value: 'medical', label: 'Medical / Healthcare' },
  { value: 'education', label: 'Education' },
  { value: 'religious_institution', label: 'Religious Institution' },
  { value: 'warehouse', label: 'Warehouse' },
  { value: 'others', label: 'Other' }
];

const GENRE_OPTIONS = [
  'pop', 'rock', 'hip_hop', 'rnb', 'jazz', 'classical',
  'country', 'latin', 'acoustic', 'lounge', 'ambient', 'gospel', 'workout', 'reggae', 'afrobeats'
];

const US_STATES = [
  'AL','AK','AZ','AR','CA','CO','CT','DE','FL','GA','HI','ID','IL','IN','IA','KS','KY',
  'LA','ME','MD','MA','MI','MN','MS','MO','MT','NE','NV','NH','NJ','NM','NY','NC','ND',
  'OH','OK','OR','PA','RI','SC','SD','TN','TX','UT','VT','VA','WA','WV','WI','WY','DC'
];

const DEFAULT_LOCATION = {
  name: '', address: '', city: '', state: '', zip_code: '',
  business_type: 'retail_store', sub_type: '',
  music_override_enabled: false, preferred_genres: [], preferred_moods: [],
  preferred_tempo: 'moderate', explicit_content: false
};

const Svg = ({ type, size = 16 }) => {
  const icons = {
    pin: <><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/></>,
    radio: <><path d="M4.9 19.1C1 15.2 1 8.8 4.9 4.9"/><path d="M7.8 16.2c-2.3-2.3-2.3-6.1 0-8.4"/><circle cx="12" cy="12" r="2"/><path d="M16.2 7.8c2.3 2.3 2.3 6.1 0 8.4"/><path d="M19.1 4.9C23 8.8 23 15.1 19.1 19"/></>,
    edit: <><path d="M12 20h9"/><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z"/></>,
    trash: <><polyline points="3,6 5,6 21,6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></>,
    plus: <><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></>,
    globe: <><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></>,
    calendar: <><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></>,
    link: <><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></>,
    arrow: <><polyline points="9,18 15,12 9,6"/></>,
    warn: <><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></>,
    qr: <><rect x="2" y="2" width="8" height="8" rx="1"/><rect x="14" y="2" width="8" height="8" rx="1"/><rect x="2" y="14" width="8" height="8" rx="1"/><rect x="14" y="14" width="4" height="4"/><rect x="18" y="18" width="4" height="4"/><rect x="14" y="18" width="4" height="4"/><rect x="18" y="14" width="4" height="4"/></>,
    download: <><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7,10 12,15 17,10"/><line x1="12" y1="15" x2="12" y2="3"/></>,
    building: <><rect x="4" y="2" width="16" height="20" rx="2" ry="2"/><path d="M9 22v-4h6v4"/><path d="M8 6h.01"/><path d="M16 6h.01"/><path d="M12 6h.01"/><path d="M12 10h.01"/><path d="M12 14h.01"/><path d="M16 10h.01"/><path d="M16 14h.01"/><path d="M8 10h.01"/><path d="M8 14h.01"/></>,
  };
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">{icons[type]}</svg>
  );
};

const inputStyle = {
  width: '100%', border: '1.5px solid #e5e7eb', borderRadius: 10,
  padding: '11px 14px', fontSize: 14, outline: 'none',
  fontFamily: "'Outfit', sans-serif", boxSizing: 'border-box',
  transition: 'border-color 0.15s',
};

export default function Locations() {
  const navigate = useNavigate();
  const [locations, setLocations] = useState([]);
  const [channels, setChannels] = useState([]);
  const [programs, setPrograms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [formData, setFormData] = useState({ ...DEFAULT_LOCATION });
  const [editingId, setEditingId] = useState(null);
  const [saving, setSaving] = useState(false);
  const [billingNote, setBillingNote] = useState(null);  // Wave 2: next-cycle billing message at the moment of add/delete
  const token = localStorage.getItem('token');
  const headers = { 'Authorization': `Bearer ${token}` };
  const jsonHeaders = { ...headers, 'Content-Type': 'application/json' };

  useEffect(() => {
    if (!token) { navigate('/login'); return; }
    fetchAll();
  }, [token, navigate]);

  useEffect(() => {
    if (billingNote) {
      const t = setTimeout(() => setBillingNote(null), 8000);
      return () => clearTimeout(t);
    }
  }, [billingNote]);

  const fetchAll = async () => {
    setLoading(true);
    await Promise.all([fetchLocations(), fetchChannels(), fetchPrograms()]);
    setLoading(false);
  };

  const fetchLocations = async () => {
    try {
      const res = await fetch(`${API}/locations`, { headers });
      if (res.status === 401) { navigate('/login'); return; }
      if (res.ok) { const data = await res.json(); setLocations(data.locations || []); }
    } catch (err) { console.error(err); }
  };

  const fetchChannels = async () => {
    try {
      const res = await fetch(`${API}/channels`, { headers });
      if (res.ok) { const data = await res.json(); setChannels(data.channels || []); }
    } catch (err) { console.error(err); }
  };

  const fetchPrograms = async () => {
    try {
      const res = await fetch(`${API}/radio-programs`, { headers });
      if (res.ok) { const data = await res.json(); setPrograms(data.programs || []); }
    } catch (err) { console.error(err); }
  };

  const handleCreate = async (e) => {
    e.preventDefault(); setSaving(true);
    try {
      const res = await fetch(`${API}/locations`, { method: 'POST', headers: jsonHeaders, body: JSON.stringify(formData) });
      if (!res.ok) throw new Error('Failed');
      const data = await res.json().catch(() => ({}));
      const b = data.billing || {};
      if (b.monthly_total) {
        setBillingNote({ type: 'add', text: `Location added. No charge today — your next bill becomes $${b.monthly_total}/mo ($89 per location).` });
      } else {
        setBillingNote({ type: 'add', text: `Location added. It's free during your trial; you'll be billed $89 per location when you subscribe.` });
      }
      await fetchAll(); setShowCreateModal(false); setFormData({ ...DEFAULT_LOCATION });
    } catch (err) { alert('Failed to create: ' + err.message); }
    finally { setSaving(false); }
  };

  const handleEdit = async (e) => {
    e.preventDefault(); setSaving(true);
    try {
      const res = await fetch(`${API}/locations/${editingId}`, { method: 'PUT', headers: jsonHeaders, body: JSON.stringify(formData) });
      if (!res.ok) throw new Error('Failed');
      await fetchAll(); setShowEditModal(false);
    } catch (err) { alert('Failed to update: ' + err.message); }
    finally { setSaving(false); }
  };

  const handleDelete = async (id, name) => {
    const locChannels = channels.filter(c => c.location_id === id);
    const channelWarn = locChannels.length > 0
      ? `This will also affect ${locChannels.length} channel(s) linked to "${name}". `
      : '';
    // Wave 2: state next-cycle behavior before the irreversible action.
    const warning = `${channelWarn}Delete location "${name}"?\n\nThis location stays live until the end of your current billing cycle (you've already paid for it). Your next bill drops by $89. No charge or refund today.`;
    if (!window.confirm(warning)) return;
    try {
      const res = await fetch(`${API}/locations/${id}`, { method: 'DELETE', headers });
      if (!res.ok) throw new Error('Failed');
      const data = await res.json().catch(() => ({}));
      const b = data.billing || {};
      if (b.monthly_total) {
        setBillingNote({ type: 'delete', text: `Location removed. It stays live until your cycle ends; your next bill becomes $${b.monthly_total}/mo.` });
      } else {
        setBillingNote({ type: 'delete', text: `Location removed.` });
      }
      await fetchAll();
    } catch (err) { alert('Failed to delete'); }
  };

  const openEdit = (loc) => {
    setFormData({
      name: loc.name || '', address: loc.address || '', city: loc.city || '',
      state: loc.state || '', zip_code: loc.zip_code || '',
      business_type: loc.business_type || 'retail_store', sub_type: loc.sub_type || '',
      music_override_enabled: loc.music_override_enabled || false,
      preferred_genres: loc.preferred_genres || [], preferred_moods: loc.preferred_moods || [],
      preferred_tempo: loc.preferred_tempo || 'moderate', explicit_content: loc.explicit_content || false
    });
    setEditingId(loc.id); setShowEditModal(true);
  };

  const toggleGenre = (genre) => {
    setFormData(prev => ({
      ...prev,
      preferred_genres: prev.preferred_genres.includes(genre)
        ? prev.preferred_genres.filter(g => g !== genre) : [...prev.preferred_genres, genre]
    }));
  };

  const getChannelsForLocation = (locId) => channels.filter(c => c.location_id === locId);
  const getProgramCountForChannel = (chId) => programs.filter(p => p.channel_id === chId).length;
  const getBusinessLabel = (val) => BUSINESS_TYPES.find(b => b.value === val)?.label || val;

  if (loading) {
    return (
      <div style={{ padding: 40, display: 'flex', justifyContent: 'center' }}>
        <div style={{ width: 48, height: 48, borderRadius: '50%', border: '3px solid #e9d5ff', borderTopColor: '#7c3aed', animation: 'spin 0.8s linear infinite' }} />
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  return (
    <div style={{ padding: '32px 40px', maxWidth: 1200, margin: '0 auto', fontFamily: "'Outfit', 'DM Sans', sans-serif" }}>
      {billingNote && (
        <div style={{
          position: 'fixed', top: 24, right: 24, zIndex: 300, maxWidth: 380, padding: '14px 18px', borderRadius: 12,
          fontSize: 13.5, fontWeight: 600, lineHeight: 1.45, boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
          background: '#f5f3ff', color: '#5b21b6', border: '1px solid #ddd6fe',
        }}>
          {billingNote.text}
          <button onClick={() => setBillingNote(null)} style={{ marginLeft: 10, background: 'none', border: 'none', color: '#7c3aed', cursor: 'pointer', fontWeight: 700 }}>×</button>
        </div>
      )}
      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 28 }}>
        <div>
          <h1 style={{ fontSize: 26, fontWeight: 700, color: '#111827', margin: 0, letterSpacing: '-0.5px' }}>Locations</h1>
          <p style={{ fontSize: 14, color: '#9ca3af', marginTop: 4 }}>
            {locations.length} location{locations.length !== 1 ? 's' : ''} &middot; {channels.length} channel{channels.length !== 1 ? 's' : ''} total
          </p>
        </div>
        <button onClick={() => { setFormData({ ...DEFAULT_LOCATION }); setShowCreateModal(true); }}
          style={{
            display: 'flex', alignItems: 'center', gap: 8,
            background: 'linear-gradient(135deg, #7c3aed 0%, #a855f7 100%)',
            color: '#fff', border: 'none', borderRadius: 12,
            padding: '12px 24px', fontSize: 14, fontWeight: 600,
            cursor: 'pointer', fontFamily: "'Outfit', sans-serif",
            boxShadow: '0 4px 12px rgba(124,58,237,0.3)',
            transition: 'transform 0.15s, box-shadow 0.15s',
          }}
          onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-1px)'; e.currentTarget.style.boxShadow = '0 6px 20px rgba(124,58,237,0.4)'; }}
          onMouseLeave={(e) => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = '0 4px 12px rgba(124,58,237,0.3)'; }}
        >
          <Svg type="plus" size={18} /> Add Location
        </button>
      </div>

      {/* Hierarchy hint */}
      <div style={{
        background: '#f5f3ff', border: '1px solid #e9d5ff', borderRadius: 14,
        padding: '14px 18px', marginBottom: 24, display: 'flex', alignItems: 'center', gap: 12,
        fontSize: 13, color: '#6d28d9',
      }}>
        <Svg type="building" size={20} />
        <span><strong>Location</strong> &rarr; <strong>Channels</strong> &rarr; <strong>Programs</strong>: Each physical location has radio channels, and each channel has a weekly program schedule.</span>
      </div>

      {/* Empty State */}
      {locations.length === 0 ? (
        <div style={{
          textAlign: 'center', padding: '64px 24px',
          background: '#fff', borderRadius: 16, border: '1px solid #e5e7eb',
        }}>
          <div style={{ color: '#9ca3af', marginBottom: 16 }}><Svg type="pin" size={48} /></div>
          <h3 style={{ fontSize: 20, fontWeight: 700, color: '#374151', margin: '0 0 8px' }}>No locations yet</h3>
          <p style={{ fontSize: 14, color: '#9ca3af', margin: '0 0 24px' }}>Add your first business location to get started.</p>
          <button onClick={() => { setFormData({ ...DEFAULT_LOCATION }); setShowCreateModal(true); }}
            style={{
              background: 'linear-gradient(135deg, #7c3aed, #a855f7)', color: '#fff',
              border: 'none', borderRadius: 10, padding: '12px 28px',
              fontSize: 14, fontWeight: 600, cursor: 'pointer',
            }}>Add Your First Location</button>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          {locations.map(loc => {
            const locChannels = getChannelsForLocation(loc.id);
            return (
              <div key={loc.id} style={{
                background: '#fff', borderRadius: 16, border: '1px solid #e5e7eb',
                overflow: 'hidden', transition: 'box-shadow 0.15s',
              }}
              onMouseEnter={(e) => e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.05)'}
              onMouseLeave={(e) => e.currentTarget.style.boxShadow = 'none'}
              >
                {/* Location Header */}
                <div style={{ padding: '20px 24px', borderBottom: '1px solid #f3f4f6' }}>
                  <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
                    <div style={{ flex: 1 }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6 }}>
                        <h2 style={{ fontSize: 18, fontWeight: 700, color: '#111827', margin: 0 }}>{loc.name}</h2>
                        <span style={{
                          padding: '3px 12px', borderRadius: 20,
                          fontSize: 11, fontWeight: 600,
                          background: '#f5f3ff', color: '#7c3aed',
                        }}>{getBusinessLabel(loc.business_type)}</span>
                        {loc.is_active === false && (
                          <span style={{
                            padding: '3px 12px', borderRadius: 20,
                            fontSize: 11, fontWeight: 600,
                            background: '#fef2f2', color: '#dc2626',
                          }}>Inactive</span>
                        )}
                      </div>
                      <p style={{ fontSize: 13, color: '#6b7280', margin: 0 }}>
                        {[loc.address, loc.city, loc.state, loc.zip_code].filter(Boolean).join(', ')}
                      </p>
                      {loc.preferred_genres?.length > 0 && (
                        <div style={{ display: 'flex', gap: 6, marginTop: 10, flexWrap: 'wrap' }}>
                          {loc.preferred_genres.map(g => (
                            <span key={g} style={{
                              padding: '2px 10px', borderRadius: 20,
                              fontSize: 11, fontWeight: 500,
                              background: '#f3f4f6', color: '#6b7280',
                              textTransform: 'capitalize',
                            }}>{g.replace('_', ' ')}</span>
                          ))}
                        </div>
                      )}
                    </div>
                    <div style={{ display: 'flex', gap: 8 }}>
                      <button onClick={() => {
                        const url = `${API.replace('/api/v1', '')}/api/v1/qrcodes/location/${loc.id}?branded=true`;
                        window.open(url, '_blank');
                      }}
                        title="Download QR Code"
                        style={{
                          display: 'flex', alignItems: 'center', gap: 6,
                          padding: '8px 16px', borderRadius: 10, fontSize: 13, fontWeight: 600,
                          border: 'none', cursor: 'pointer',
                          background: '#ecfdf5', color: '#059669',
                        }}>
                        <Svg type="qr" size={14} /> QR Code
                      </button>
                      <button onClick={() => navigate(`/channels?location=${loc.id}`)}
                        style={{
                          display: 'flex', alignItems: 'center', gap: 6,
                          padding: '8px 16px', borderRadius: 10, fontSize: 13, fontWeight: 600,
                          border: 'none', cursor: 'pointer',
                          background: '#f5f3ff', color: '#7c3aed',
                        }}>
                        <Svg type="plus" size={14} /> Channel
                      </button>
                      <button onClick={() => openEdit(loc)} style={{
                        padding: 8, borderRadius: 8, border: 'none', cursor: 'pointer',
                        background: 'transparent', color: '#9ca3af',
                      }}
                      onMouseEnter={(e) => e.currentTarget.style.color = '#7c3aed'}
                      onMouseLeave={(e) => e.currentTarget.style.color = '#9ca3af'}
                      ><Svg type="edit" size={15} /></button>
                      <button onClick={() => handleDelete(loc.id, loc.name)} style={{
                        padding: 8, borderRadius: 8, border: 'none', cursor: 'pointer',
                        background: 'transparent', color: '#d1d5db',
                      }}
                      onMouseEnter={(e) => e.currentTarget.style.color = '#ef4444'}
                      onMouseLeave={(e) => e.currentTarget.style.color = '#d1d5db'}
                      ><Svg type="trash" size={15} /></button>
                    </div>
                  </div>
                </div>

                {/* Channels */}
                <div style={{ padding: '14px 24px', background: '#fafafa' }}>
                  {locChannels.length === 0 ? (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '8px 0', fontSize: 13, color: '#9ca3af' }}>
                      <Svg type="radio" size={14} />
                      <span>No channels yet &mdash;</span>
                      <button onClick={() => navigate(`/channels?location=${loc.id}`)}
                        style={{ background: 'none', border: 'none', color: '#7c3aed', cursor: 'pointer', fontWeight: 600, fontSize: 13, padding: 0 }}>
                        Add a channel
                      </button>
                    </div>
                  ) : (
                    <div>
                      <div style={{ fontSize: 10, fontWeight: 700, color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '1.2px', marginBottom: 10 }}>
                        Channels ({locChannels.length})
                      </div>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                        {locChannels.map(ch => {
                          const progCount = getProgramCountForChannel(ch.id);
                          return (
                            <div key={ch.id} style={{
                              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                              background: '#fff', borderRadius: 10, padding: '12px 16px',
                              border: '1px solid #e5e7eb',
                            }}>
                              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                <div style={{
                                  background: 'linear-gradient(135deg, #7c3aed, #a855f7)',
                                  borderRadius: 8, padding: 6, color: '#fff',
                                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                                }}>
                                  <Svg type="radio" size={14} />
                                </div>
                                <div>
                                  <div style={{ fontSize: 14, fontWeight: 600, color: '#111827' }}>{ch.name}</div>
                                  <div style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 11, color: '#9ca3af', marginTop: 2 }}>
                                    {ch.is_public && (
                                      <span style={{ display: 'flex', alignItems: 'center', gap: 3, color: '#059669' }}>
                                        <Svg type="globe" size={10} /> Public
                                      </span>
                                    )}
                                    {ch.azuracast_station_id && (
                                      <span style={{ display: 'flex', alignItems: 'center', gap: 3 }}>
                                        <Svg type="link" size={10} /> Connected
                                      </span>
                                    )}
                                    {progCount > 0 && (
                                      <span style={{ display: 'flex', alignItems: 'center', gap: 3 }}>
                                        <Svg type="calendar" size={10} /> {progCount} programs
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </div>
                              <div style={{ display: 'flex', gap: 6 }}>
                                <button onClick={() => navigate(`/radio-programs?channel=${ch.id}`)}
                                  style={{
                                    padding: '6px 14px', borderRadius: 8, fontSize: 12, fontWeight: 600,
                                    border: 'none', cursor: 'pointer',
                                    background: '#f5f3ff', color: '#7c3aed',
                                  }}>Schedule</button>
                                <button onClick={() => navigate('/channels')}
                                  style={{
                                    padding: '6px 14px', borderRadius: 8, fontSize: 12, fontWeight: 600,
                                    border: 'none', cursor: 'pointer',
                                    background: '#f3f4f6', color: '#6b7280',
                                  }}>Manage</button>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            );
          })}

          {/* Unlinked channels warning */}
          {channels.filter(c => !c.location_id).length > 0 && (
            <div style={{
              background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 14,
              padding: '14px 18px', display: 'flex', alignItems: 'flex-start', gap: 12,
            }}>
              <div style={{ color: '#d97706', flexShrink: 0, marginTop: 2 }}><Svg type="warn" size={18} /></div>
              <div>
                <div style={{ fontSize: 13, fontWeight: 600, color: '#92400e' }}>
                  {channels.filter(c => !c.location_id).length} channel(s) not linked to any location
                </div>
                <div style={{ fontSize: 12, color: '#b45309', marginTop: 4 }}>
                  {channels.filter(c => !c.location_id).map(c => c.name).join(', ')}
                  {' \u2014 '}
                  <button onClick={() => navigate('/channels')}
                    style={{ background: 'none', border: 'none', color: '#92400e', cursor: 'pointer', fontWeight: 600, textDecoration: 'underline', fontSize: 12, padding: 0 }}>
                    Edit channels
                  </button> to assign them.
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      {/* CREATE / EDIT MODAL */}
      {(showCreateModal || showEditModal) && (
        <div style={{
          position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          zIndex: 50, padding: 16, backdropFilter: 'blur(4px)',
        }}>
          <div style={{
            background: '#fff', borderRadius: 20, width: '100%', maxWidth: 520,
            maxHeight: '90vh', overflowY: 'auto', padding: 32,
            boxShadow: '0 25px 60px rgba(0,0,0,0.15)',
          }}>
            <h2 style={{ fontSize: 22, fontWeight: 700, color: '#111827', margin: '0 0 24px', letterSpacing: '-0.3px' }}>
              {showEditModal ? 'Edit Location' : 'New Location'}
            </h2>
            <form onSubmit={showEditModal ? handleEdit : handleCreate}>
              <div style={{ marginBottom: 18 }}>
                <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6 }}>Location Name *</label>
                <input type="text" required value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  placeholder="e.g. Downtown Store" style={inputStyle}
                  onFocus={(e) => e.target.style.borderColor = '#7c3aed'}
                  onBlur={(e) => e.target.style.borderColor = '#e5e7eb'} />
              </div>
              <div style={{ marginBottom: 18 }}>
                <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6 }}>Address</label>
                <input type="text" value={formData.address}
                  onChange={(e) => setFormData({ ...formData, address: e.target.value })}
                  placeholder="123 Main Street" style={inputStyle}
                  onFocus={(e) => e.target.style.borderColor = '#7c3aed'}
                  onBlur={(e) => e.target.style.borderColor = '#e5e7eb'} />
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12, marginBottom: 18 }}>
                <div>
                  <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6 }}>City</label>
                  <input type="text" value={formData.city}
                    onChange={(e) => setFormData({ ...formData, city: e.target.value })}
                    style={inputStyle}
                    onFocus={(e) => e.target.style.borderColor = '#7c3aed'}
                    onBlur={(e) => e.target.style.borderColor = '#e5e7eb'} />
                </div>
                <div>
                  <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6 }}>State</label>
                  <select value={formData.state}
                    onChange={(e) => setFormData({ ...formData, state: e.target.value })}
                    style={{ ...inputStyle, background: '#fff' }}>
                    <option value="">--</option>
                    {US_STATES.map(s => <option key={s} value={s}>{s}</option>)}
                  </select>
                </div>
                <div>
                  <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6 }}>ZIP</label>
                  <input type="text" value={formData.zip_code}
                    onChange={(e) => setFormData({ ...formData, zip_code: e.target.value })}
                    style={inputStyle}
                    onFocus={(e) => e.target.style.borderColor = '#7c3aed'}
                    onBlur={(e) => e.target.style.borderColor = '#e5e7eb'} />
                </div>
              </div>
              <div style={{ marginBottom: 18 }}>
                <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6 }}>Business Type *</label>
                <select value={formData.business_type}
                  onChange={(e) => setFormData({ ...formData, business_type: e.target.value })}
                  style={{ ...inputStyle, background: '#fff' }}>
                  {BUSINESS_TYPES.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
                </select>
              </div>
              <div style={{ marginBottom: 24 }}>
                <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 8 }}>
                  Preferred Genres {formData.preferred_genres.length > 0 && `(${formData.preferred_genres.length})`}
                </label>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                  {GENRE_OPTIONS.map(g => (
                    <button key={g} type="button" onClick={() => toggleGenre(g)}
                      style={{
                        padding: '6px 14px', borderRadius: 20, fontSize: 12, fontWeight: 600,
                        border: 'none', cursor: 'pointer', textTransform: 'capitalize',
                        transition: 'all 0.15s',
                        background: formData.preferred_genres.includes(g) ? '#7c3aed' : '#f3f4f6',
                        color: formData.preferred_genres.includes(g) ? '#fff' : '#6b7280',
                      }}>{g.replace('_', ' ')}</button>
                  ))}
                </div>
              </div>
              <div style={{ display: 'flex', gap: 12, borderTop: '1px solid #f3f4f6', paddingTop: 20 }}>
                <button type="button" onClick={() => { setShowCreateModal(false); setShowEditModal(false); }}
                  style={{
                    flex: 1, padding: '12px 20px', borderRadius: 10,
                    border: '1.5px solid #e5e7eb', background: '#fff',
                    color: '#374151', fontSize: 14, fontWeight: 600, cursor: 'pointer',
                    fontFamily: "'Outfit', sans-serif",
                  }}>Cancel</button>
                <button type="submit" disabled={saving}
                  style={{
                    flex: 1, padding: '12px 20px', borderRadius: 10,
                    border: 'none', background: saving ? '#c4b5fd' : 'linear-gradient(135deg, #7c3aed, #a855f7)',
                    color: '#fff', fontSize: 14, fontWeight: 600, cursor: saving ? 'not-allowed' : 'pointer',
                    fontFamily: "'Outfit', sans-serif",
                    boxShadow: '0 4px 12px rgba(124,58,237,0.3)',
                  }}>{saving ? 'Saving...' : (showEditModal ? 'Save Changes' : 'Create Location')}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}